<script setup>
defineProps({id:{type:String,required:true},blockId:{type:String,default:'R-A-20123375-4'}});
const slot=ref(null);
const fits=ref(false);
const started=ref(false);
let observer;
onMounted(()=>{
 const update=()=>{
  fits.value=slot.value.getBoundingClientRect().width>=320;
  if(fits.value)started.value=true;
 };
 observer=new ResizeObserver(update);
 observer.observe(slot.value);
 update();
});
onBeforeUnmount(()=>observer?.disconnect());
</script>
<template>
 <div ref="slot" class="ad-banner-320" :data-ad-fits="fits">
  <div v-if="started" v-show="fits"><AdContainer :id="id" :block-id="blockId" /></div>
 </div>
</template>
<style scoped>
.ad-banner-320{width:320px;max-width:100%;min-width:0;margin-inline:auto;}
</style>
